import { JSX } from "react";
import { LinkProps, Outlet } from "@tanstack/react-router";
import { IconPalette, IconUser } from "@tabler/icons-react";
import { Separator } from "@/components/ui/separator";
import SidebarNav from "@/components/sidebar-nav";
import RootUserLayout from "../layout";

export default function Settings() {
  return (
    <RootUserLayout
      pageTitle="Settings"
      pageDescription="Manage your account settings and set e-mail preferences."
    >
      <Separator className="my-4 lg:my-6" />
      <div className="flex flex-1 flex-col space-y-2 overflow-hidden md:space-y-2 lg:flex-row lg:space-x-12 lg:space-y-0">
        <aside className="top-0 lg:sticky lg:w-1/5">
          <SidebarNav items={sidebarNavItems} />
        </aside>
        <div className="flex w-full overflow-y-hidden p-1 pr-4">
          <Outlet />
        </div>
      </div>
    </RootUserLayout>
  );
}

const sidebarNavItems: Array<{
  title: string;
  icon: JSX.Element;
  href: Required<LinkProps>["to"];
}> = [
  {
    title: "Profile",
    icon: <IconUser size={18} />,
    href: "/root-user/settings/profile",
  },
  {
    title: "Appearance",
    icon: <IconPalette size={18} />,
    href: "/root-user/settings/appearance",
  },
];
